import React, { useEffect, useState } from "react";
import Pagination from '../../../../components/Pagination';
import Loader from '../../../../components/Loader';
import EditableTable from "./Table";
import Modal from "../../../../components/Modal"
import ChangeLog from "../../../../components/ChangeLog";
import api from "../../../../auth/api";
import { alertSuccess, alertError } from "../../../../components/Alert";

import { CompleteModalContent, CancelledModalContent } from "./ActionModals";

export default function GiftCardRequests() {
  const [data, setData] = useState([]);
  // const dispatch = useDispatch();
  const [changeLogData, setChangeLogData] = useState([])
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [editRowId, setEditRowId] = useState(null);
  const [editedData, setEditedData] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentLog, setCurrentLog] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [activeActionModal, setActiveActionModal] = useState(null);
  const [selectedActionRow, setSelectedActionRow] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const editableFields = ['title', 'detail', 'points', 'stock', 'status', 'agency', 'brand', 'value', 'country'];
  const itemPerPage = 10;
  // const [addDis, setAddDis] = useState(false);
  // const [agencyList, setAgencyList] = useState([]);
  // const { countryList, status } = useSelector((state) => state.countryList);
  // const [brandList, setBrandList] = useState([])

  useEffect(() => {
    fetchData();
    // getAgencyList();
    // getBrandList();
  }, [currentPage]);


  // useEffect(() => {
  //   if (status === 'idle') {
  //     dispatch(fetchCountryList());
  //   }
  // }, [dispatch, status])

  const fetchData = async () => {
    try {

      const response = await api.get(`/redeem/panel/gift/card/requests?page=${currentPage}`);
      setData(response.data.result);
      let pageCount = Math.ceil(response?.data?.pagination?.count / itemPerPage);
      setTotalPages(pageCount);
      setChangeLogData(response.data.Change_Log);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };


  // const getAgencyList = async () => {
  //   try {
  //     const response = await api.get("/redeem/panel/agency");
  //     setAgencyList(response.data.result);
  //   } catch (error) {
  //     console.error("Error fetching data:", error);
  //   }
  // };


  // const getBrandList = async () => {
  //   try {
  //     const response = await api.get("/redeem/panel/brands");
  //     setBrandList(response.data.result);
  //   } catch (error) {
  //     console.error("Error fetching data:", error);
  //   }
  // };


  const handleEdit = (rowId) => {
    setEditRowId(rowId);
    const rowData = data.find((item) => item.id === rowId);
    setEditedData(rowData);
  };

  const handleSave = async () => {
    try {



      const finalData = {
        id: editedData.id,
        title: editedData.title,
        detail: editedData.detail,
        points: editedData.points,
        stock: editedData.stock,
        status: editedData.status,
        value: editedData.value,
        productId: editedData.productId,
      }

      await api.patch(`/redeem/panel/gift/card`, finalData);
      alertSuccess("Data updated successfully");
      setEditRowId(null);
      fetchData();
    } catch (error) {
      alertError(error?.response?.data?.errors)
      console.error("Error updating data:", error);
    }

  };



  const handleLog = (id) => {
    const logData = changeLogData.filter((f) => f.id === id)[0]?.oldTrack;
    console.log(JSON.stringify(logData));
    setCurrentLog(logData);
    setIsModalOpen(true);
  };



  const handleChange = (e, field, val) => {
    if (field === "is_active" || field === "editable" || field === "optional" || field === "status") {
      setEditedData((prev) => ({
        ...prev,
        [field]: !val,
      }));
    } else {
      setEditedData((prev) => ({
        ...prev,
        [field]: e.target.value,
      }));
    }
  };

  const handleCancel = () => {
    setEditRowId(null);
    setEditedData({});
  };



  const headers = data.length > 0 ? Object.keys(data[0]).filter(key => key !== 'id') : [];

  const handleUploadImage = async (row, file) => {
    try {
      const formData = new FormData();
      formData.append("productImage", file);
      formData.append("id", row.id); // if ID is required by backend
      const response = await api.patch(`/redeem/panel/gift/card`, formData, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      });
      alertSuccess("Image uploaded successfully");
      fetchData(); // Refresh table
    } catch (error) {
      console.error("Image upload failed:", error);
      alertError(error?.response?.data?.errors || "Upload failed");
    }
  };




  if (loading) return <Loader />;

  const handleCompleteClick = (row) => {
    setSelectedActionRow(row);
    setActiveActionModal("complete");
  };

  const handleCancelledClick = (row) => {
    setSelectedActionRow(row);
    setActiveActionModal("cancelled");
  };

  const handleCompleteSubmit = async (formData) => {
    setSubmitting(true);
    try {
      const payload = {
        id: selectedActionRow.id,
        ...formData
      };
      await api.patch("/redeem/panel/gift/card/request/complete", payload);
      alertSuccess("Request completed successfully");
      setActiveActionModal(null);
      setSelectedActionRow(null);
      fetchData();
    } catch (error) {
      console.error("Error completing request:", error);
      alertError(error?.response?.data?.errors || "Operation failed");
    } finally {
      setSubmitting(false);
    }
  };

  const handleCancelledSubmit = async (formData) => {
    setSubmitting(true);
    try {
      const payload = {
        id: selectedActionRow.id,
        ...formData
      };
      await api.patch("/redeem/panel/gift/card/request/cancelled", payload);
      alertSuccess("Request cancelled successfully");
      setActiveActionModal(null);
      setSelectedActionRow(null);
      fetchData();
    } catch (error) {
      console.error("Error cancelling request:", error);
      alertError(error?.response?.data?.errors || "Operation failed");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="w-full flex items-center flex-col">
      <EditableTable
        headers={headers}
        rows={data}
        editRowId={editRowId}
        editedData={editedData}
        handleEdit={handleEdit}
        handleSave={handleSave}
        handleCancel={handleCancel}
        editableFields={editableFields}
        handleChange={handleChange}
        handleLog={handleLog}
        handleUploadImage={handleUploadImage}
        fetchData={fetchData}
        hideChangeLog={true}
        onComplete={handleCompleteClick}
        onCancelled={handleCancelledClick}
      // agencyList={agencyList}
      // countryList={countryList?.result}
      // brandList={brandList}
      />

      <div className="flex mt-4 items-center justify-between w-11/12">
        <Pagination currentPage={currentPage} setCurrentPage={setCurrentPage} totalPages={totalPages} />

      </div>
      <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} title="Change Log" content={<ChangeLog data={currentLog} />} />

      <Modal
        isOpen={activeActionModal === "complete"}
        onClose={() => setActiveActionModal(null)}
        title="Complete Request"
        content={
          <CompleteModalContent
            onSubmit={handleCompleteSubmit}
            onClose={() => setActiveActionModal(null)}
            loading={submitting}
          />
        }
      />

      <Modal
        isOpen={activeActionModal === "cancelled"}
        onClose={() => setActiveActionModal(null)}
        title="Cancel Request"
        content={
          <CancelledModalContent
            onSubmit={handleCancelledSubmit}
            onClose={() => setActiveActionModal(null)}
            loading={submitting}
          />
        }
      />

      {/* <Modal isOpen={addDis} onClose={() => setAddDis(false)} title="Add Gift Card" content={<Add onSuccess={fetchData} agencyList={agencyList} countryList={countryList?.result} brandList={brandList} />} /> */}
    </div>
  );
}
